export default "__VITE_ASSET__Wylm6qDd__"